module.exports = {
  GOOGLETV: 1,
  GOOGLEGLASS: 2,
  ANDROIDWEAR: 4,
  ANDROIDTV: 8,
  NOKIAX: 16,
  FIREOS: 32,
  UIQ: 64,
  S60: 128,
  MOAPS: 256,
};
